/* eslint-disable */
// @ts-nocheck
import React, { useContext, useEffect, useState } from "react";
import Tabs from "../ui/tabs/Tabs";
import TabPanels from "../ui/tabs/TabPanels";
import TabPanel from "../ui/tabs/TabPanel";
import useSummaryApis from "../hooks/useSummaryApis";
import AuthContext from "../store/authContext";
import InlineLoader from "../components/loader/InlineLoader";
import DashBoardTabList from "../ui/tabs/DashBoardTabList";
import SectionHeader from "../components/section/SectionHeader";
import ESOganisationDropdown from "../components/dropdown/esOrganisationDropdown";
import OrgContext from "../store/orgContext";
import Tiles from "../components/tiles/Tiles";
import LineCharts from "../components/charts/LineCharts";
import ChartModal from "../components/modal/ChartModal";
import SmallTiles, { Icons } from "../components/tiles/SmallTiles";
import InfoAlert from "../ui/InfoAlert";
import {
  PERMISSIONS_TRANSLATIONS,
  READ_OVERVIEW_TRANSLATION,
  TAB_LIST_TRANSLATIONS,
  TILE_LIST_TRANSLATIONS,
} from "../translations/util";
import useAppTitle from "../hooks/useAppTitle";

const TABS_LIST = [
  TAB_LIST_TRANSLATIONS.ConfigurationManagement,
  TAB_LIST_TRANSLATIONS.RealTimeManagement,
];
const ConfigTileList = {
  "LMR Users": TILE_LIST_TRANSLATIONS.ConfigurationManagement.LMRUsers,
  "LMR Groups": TILE_LIST_TRANSLATIONS.ConfigurationManagement.LMRGroups,
  "LMR Messages": TILE_LIST_TRANSLATIONS.ConfigurationManagement.LMRMessages,
  "MC Groups": TILE_LIST_TRANSLATIONS.ConfigurationManagement.MCGroups,
  "MC Users": TILE_LIST_TRANSLATIONS.ConfigurationManagement.MCUsers,
  "DFSI Groups": TILE_LIST_TRANSLATIONS.ConfigurationManagement.DFSIGroups,
  "DFSI Channels": TILE_LIST_TRANSLATIONS.ConfigurationManagement.DFSIChannels,
  "DFSI Connections":
    TILE_LIST_TRANSLATIONS.ConfigurationManagement.DFSIConnections,
  "XSSI Connections":
    TILE_LIST_TRANSLATIONS.ConfigurationManagement.XSSIConnections,
  "OTAR Connections":
    TILE_LIST_TRANSLATIONS.ConfigurationManagement.OTARConnections,
};

const RealTimeTileList = {
  "Publish Info": TILE_LIST_TRANSLATIONS.RealTimeManagement.PublishInfo,
  "P25 Supp. Service Reg. (Unit)":
    TILE_LIST_TRANSLATIONS.RealTimeManagement.P25Unit,
  "P25 Supp. Service Reg. (Group)":
    TILE_LIST_TRANSLATIONS.RealTimeManagement.P25Group,
  "P25 Supp. Service Reg. (FNE)":
    TILE_LIST_TRANSLATIONS.RealTimeManagement.FixedNetwork,
  "P25 Group Affiliations":
    TILE_LIST_TRANSLATIONS.RealTimeManagement.Affiliation,
};

const OrgTileList = {
  Organisations: TILE_LIST_TRANSLATIONS.OrgTileList.Organisations,
  Mappings: TILE_LIST_TRANSLATIONS.OrgTileList.Mappings,
  Locations: TILE_LIST_TRANSLATIONS.OrgTileList.Locations,
};

const Overview = () => {
  const { token } = useContext(AuthContext);
  const { orgs: orgList } = useContext(OrgContext);
  useAppTitle("Overview- IWF Config Admin Tool (ICAT) by AT&T");
  const [index, setIndex] = useState();
  const [sortedList, setSortedList] = useState([]);
  const [showTop10Chart, setshowTop10chart] = useState(false);
  const [selectedTab, setSelectedTab] = useState("");
  const [organisationList, setOrganisationList] = useState([]);
  const [selectedOrganisation, setSelectedOrganisation] = useState({
    id: "AllOrganisation",
    text: `${READ_OVERVIEW_TRANSLATION.allOrgText} (AllOrganisation)`,
  });
  const { orgResult, configResult, realTimeResult, orgloading, configLoading } =
    useSummaryApis(token);

  const newConfigResult = configResult
    .map((obj) => obj.value)
    .filter((obj) => Object.values(obj)[0]);

  const newRealTimeResult = realTimeResult
    .map((obj) => obj.value)
    .filter((obj) => Object.values(obj)[0]);

  const neworgResult = orgResult
    .map((obj) => obj.value)
    .flatMap((ele) => ele, 1)
    .filter((obj) => Object.values(obj)[0]);

  const sortTop10 = (data: any) => {
    let sortedArray = [];
    for (const key in data) {
      sortedArray.push({ key: key, value: data[key] });
    }
    const top10SortedArray = sortedArray
      .sort((a, b) => (a.value > b.value ? -1 : 1))
      .slice(0, 10);

    setSortedList([...top10SortedArray]);
  };

  const getChartTitle = () => {
    if (selectedTab === "Config") {
      return `${ConfigTileList[index]}`;
    } else if (selectedTab === "RealTime") {
      return `${RealTimeTileList[index]}`;
    }
  };

  const handleDisplayTotal = (obj) => {
    if (selectedOrganisation.text !== "All Organisations (AllOrganisation)") {
      return obj?.org_ids_totals[selectedOrganisation.id] ?? 0;
    } else {
      return obj?.total;
    }
  };

  useEffect(() => {
    setOrganisationList([
      {
        text: `${READ_OVERVIEW_TRANSLATION.allOrgText} (AllOrganisation)`,
        id: "AllOrganisations",
      },
      ...orgList,
    ]);
  }, [orgList]);

  return (
    <div>
      <SectionHeader
        pageTitle={READ_OVERVIEW_TRANSLATION.header}
        pageDescription={READ_OVERVIEW_TRANSLATION.headerSubtext}
      />
      <div className="dashboard-row">
        {neworgResult.map((result, i) => {
          const page = Object.keys(result)[0];
          return (
            <SmallTiles
              total={Object.values(result)[0]}
              label={OrgTileList[page]}
              icon={Icons[OrgTileList[page]]}
              loading={orgloading}
            />
          );
        })}
      </div>
      <Tabs>
        <div className="dashboard-tabs ">
          <div className="data-tablist">
            <DashBoardTabList
              ariaLabel="List of dashboard tabs"
              TABS_LIST={TABS_LIST}
              className={"dashboard-tabs"}
            />
          </div>
          <div className="dropdown-details">
            <ESOganisationDropdown
              org={selectedOrganisation || undefined}
              orgsList={organisationList && organisationList}
              setOrg={(newOrg: { id: string; text: string } | null) =>
                setSelectedOrganisation(newOrg)
              }
            />
          </div>
        </div>
        <div className="overview-wrapper">
          {configLoading ? (
            <InlineLoader />
          ) : (
            <TabPanels>
              {newConfigResult.length > 0 ? (
                <TabPanel>
                  {selectedOrganisation ? (
                    <div className="dashboard-panel">
                      {newConfigResult.map((obj, i) => {
                        const page = Object.keys(obj)[0];
                        return (
                          <div className="dashboard-tile">
                            <Tiles
                              title={ConfigTileList[page]}
                              hideStyle={`${
                                selectedOrganisation.text !==
                                "All Organisations (AllOrganisation)"
                                  ? "hideTileInfo"
                                  : ""
                              }`}
                              total={handleDisplayTotal(
                                obj[ConfigTileList[page]]
                              )}
                              Avg={obj[ConfigTileList[page]]?.org_ids_avg}
                              Max={obj[ConfigTileList[page]]?.org_ids_max}
                              Min={obj[ConfigTileList[page]]?.org_ids_min}
                              disableTop10btn={
                                selectedOrganisation.text !==
                                "All Organisations (AllOrganisation)"
                              }
                              onClick={() => {
                                sortTop10(
                                  obj[ConfigTileList[page]]?.org_ids_totals
                                );
                                setIndex(page);
                                setSelectedTab("Config");
                                setshowTop10chart(!showTop10Chart);
                              }}
                            />
                            {!selectedOrganisation ||
                            selectedOrganisation.text ===
                              "All Organisations (AllOrganisation)" ? (
                              <LineCharts
                                data={{
                                  labels: [
                                    READ_OVERVIEW_TRANSLATION.lineChart
                                      .XaxisLabels.min,
                                    READ_OVERVIEW_TRANSLATION.lineChart
                                      .XaxisLabels.avg,
                                    READ_OVERVIEW_TRANSLATION.lineChart
                                      .XaxisLabels.max,
                                  ],
                                  datasets: [
                                    {
                                      data: [
                                        obj[ConfigTileList[page]]?.org_ids_min,
                                        obj[ConfigTileList[page]]?.org_ids_avg,
                                        obj[ConfigTileList[page]]?.org_ids_max,
                                      ],
                                      borderColor: "#39797C",
                                      borderWidth: 1,
                                      tension: 0.4,
                                    },
                                  ],
                                }}
                                options={{
                                  maintainAspectRatio: false,
                                  plugins: {
                                    title: {
                                      display: true,
                                      text: ConfigTileList[page],
                                    },
                                    legend: {
                                      display: false,
                                    },
                                  },
                                  scales: {
                                    y: {
                                      beginAtZero: true,
                                      ticks: {
                                        precision: 0,
                                      },
                                    },
                                  },
                                }}
                              />
                            ) : null}
                          </div>
                        );
                      })}
                    </div>
                  ) : (
                    <InfoAlert
                      heading={
                        READ_OVERVIEW_TRANSLATION.config.infoAlert.heading
                      }
                      subText={
                        READ_OVERVIEW_TRANSLATION.config.infoAlert.subText
                      }
                    />
                  )}
                </TabPanel>
              ) : (
                <TabPanel>
                  <InfoAlert
                    heading={PERMISSIONS_TRANSLATIONS.header}
                    subText={PERMISSIONS_TRANSLATIONS.subtext(
                      "view",
                      "Configuration Management summary data"
                    )}
                  />
                </TabPanel>
              )}

              {newRealTimeResult.length > 0 ? (
                <TabPanel>
                  {selectedOrganisation ? (
                    <div className="dashboard-panel">
                      {newRealTimeResult.map((obj, i) => {
                        const page = Object.keys(obj)[0];
                        return (
                          <div className="dashboard-tile">
                            <Tiles
                              title={RealTimeTileList[page]}
                              hideStyle={`${
                                selectedOrganisation.text !==
                                "All Organisations (AllOrganisation)"
                                  ? "hideTileInfo"
                                  : ""
                              }`}
                              total={handleDisplayTotal(
                                obj[RealTimeTileList[page]]
                              )}
                              Avg={obj[RealTimeTileList[page]]?.org_ids_avg}
                              Max={obj[RealTimeTileList[page]]?.org_ids_max}
                              Min={obj[RealTimeTileList[page]]?.org_ids_min}
                              disableTop10btn={
                                selectedOrganisation.text !==
                                "All Organisations (AllOrganisation)"
                              }
                              onClick={() => {
                                sortTop10(
                                  obj[RealTimeTileList[page]]?.org_ids_totals
                                );
                                setIndex(page);
                                setSelectedTab("RealTime");
                                setshowTop10chart(!showTop10Chart);
                              }}
                            />
                            {!selectedOrganisation ||
                            selectedOrganisation.text ===
                              "All Organisations (AllOrganisation)" ? (
                              <LineCharts
                                data={{
                                  labels: [
                                    READ_OVERVIEW_TRANSLATION.lineChart
                                      .XaxisLabels.min,
                                    READ_OVERVIEW_TRANSLATION.lineChart
                                      .XaxisLabels.avg,
                                    READ_OVERVIEW_TRANSLATION.lineChart
                                      .XaxisLabels.max,
                                  ],
                                  datasets: [
                                    {
                                      data: [
                                        obj[RealTimeTileList[page]]
                                          ?.org_ids_min,
                                        obj[RealTimeTileList[page]]
                                          ?.org_ids_avg,
                                        obj[RealTimeTileList[page]]
                                          ?.org_ids_max,
                                      ],
                                      borderColor: "#39797C",
                                      borderWidth: 1,
                                      tension: 0.4,
                                    },
                                  ],
                                }}
                                options={{
                                  maintainAspectRatio: false,
                                  plugins: {
                                    title: {
                                      display: true,
                                      text: RealTimeTileList[page],
                                    },
                                    legend: {
                                      display: false,
                                    },
                                  },
                                  scales: {
                                    y: {
                                      beginAtZero: true,
                                      ticks: {
                                        precision: 0,
                                      },
                                    },
                                  },
                                }}
                              />
                            ) : null}
                          </div>
                        );
                      })}
                    </div>
                  ) : (
                    <InfoAlert
                      heading={
                        READ_OVERVIEW_TRANSLATION.realtime.infoAlert.heading
                      }
                      subText={
                        READ_OVERVIEW_TRANSLATION.realtime.infoAlert.subText
                      }
                    />
                  )}
                </TabPanel>
              ) : (
                <TabPanel>
                  <InfoAlert
                    heading={PERMISSIONS_TRANSLATIONS.header}
                    subText={PERMISSIONS_TRANSLATIONS.subtext(
                      "view",
                      "Realtime summary data"
                    )}
                  />
                </TabPanel>
              )}
            </TabPanels>
          )}
        </div>
      </Tabs>
      {showTop10Chart ? (
        <ChartModal
          open={showTop10Chart}
          setOpen={setshowTop10chart}
          modalHeaderText={READ_OVERVIEW_TRANSLATION.chartModal.getChartModalHeaderText(
            selectedTab,
            ConfigTileList,
            RealTimeTileList,
            index
          )}
          modalSubHeaderText={READ_OVERVIEW_TRANSLATION.chartModal.getChartModalSubHeaderText(
            selectedTab,
            ConfigTileList,
            RealTimeTileList,
            index
          )}
          chartData={{
            labels: sortedList?.map((obj) => obj.key),
            datasets: [
              {
                backgroundColor: "#39797C",
                data: sortedList?.map((obj) => obj.value),
                maxBarThickness: 15,
              },
            ],
          }}
          chartOptions={{
            maintainAspectRatio: false,
            plugins: {
              title: {
                display: true,
                text: getChartTitle(),
                align: "start",
                color: "#161616",
              },
              legend: {
                display: false,
              },
            },
            scales: {
              x: {
                ticks: {
                  color: "#43515f",
                  font: {
                    size: 12,
                    weight: 600,
                  },
                },
              },
              y: {
                type: "logarithmic",
                suggestedMax:
                  Math.max(sortedList?.map((obj) => obj.value) || 100) + 100,
                ticks: {
                  maxTicksLimit: 11,
                  autoSkipPadding: 10,
                  callback: (yValue, idx, ticks) => {
                    if (idx === 0) {
                      return "0";
                    }
                    return Math.floor(yValue) === yValue ? yValue : null;
                  },
                  color: "#43515f",
                  font: {
                    size: 12,
                    weight: 600,
                  },
                },
              },
            },
          }}
        />
      ) : null}
    </div>
  );
};

export default Overview;
